import {
  IOccupationCard,
  OccupationCategory
} from '@cpd-app/core-module/models';
import { UtilityService } from '@cpd-app/core-module/services';
import { OccupationCardCategoryType } from '@cpd-app/generated';

const categoryConfig: Partial<{
  [key in OccupationCardCategoryType];
}> = {
  [OccupationCardCategoryType.HighGrowth]: {
    name: 'High Growth',
    description:
      'High Growth Careers are sourced from the U.S. Bureau of Labor Statistics fastest growing career list.',
    occupationCardCategoryType: OccupationCardCategoryType.HighGrowth,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  },
  [OccupationCardCategoryType.Competencies]: {
    name: 'Skills',
    description:
      'Your competency matches are identified based on your current work history and skills survey responses. These are matched with O*NET occupation data to help identify careers that align with your existing strengths.',
    occupationCardCategoryType: OccupationCardCategoryType.Competencies,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  },
  [OccupationCardCategoryType.AiFastestPath]: {
    name: 'Experience',
    description:
      'Your experience matches are identified based on your current work history and skills survey responses. Your competencies are matched with O*NET occupation data to highlight careers aligned with your skill set and focused on the fastest path to employment.',
    occupationCardCategoryType: OccupationCardCategoryType.AiFastestPath,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false,
    message: ''
  },
  [OccupationCardCategoryType.Interests]: {
    name: 'Interests',
    description:
      'Your interest matches are identified from the interests survey results which leverage the 30-question Holland Code logic. The results are matched with O*Net occupation data to identify careers that align with your interests.',
    occupationCardCategoryType: OccupationCardCategoryType.Interests,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  },
  [OccupationCardCategoryType.Lifestyle]: {
    name: 'Lifestyle',
    description:
      'Your lifestyle matches are identified from the lifestyles survey results and are matched with Department of Labor and Census Bureau occupation data to identify careers that align with your desired lifestyle.',
    occupationCardCategoryType: OccupationCardCategoryType.Lifestyle,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  },
  [OccupationCardCategoryType.HotLocations]: {
    name: 'Locations',
    description:
      'Your preferred location matches are identified from the lifestyle survey and leverages occupation data at the city level from Career One Stop in order to display careers that are in high demand in your desired location(s).',
    occupationCardCategoryType: OccupationCardCategoryType.HotLocations,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  },
  [OccupationCardCategoryType.Values]: {
    name: 'Values',
    description:
      'Your value matches are identified from the values survey results and are matched with O*Net occupation data to display careers that align with your values.',
    occupationCardCategoryType: OccupationCardCategoryType.Values,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  },
  [OccupationCardCategoryType.CareerGoals]: {
    name: 'Goals',
    description:
      'Your career goal matches are identified from  the career goal that you set and display careers that are similar.',
    occupationCardCategoryType: OccupationCardCategoryType.CareerGoals,
    occupations: [],
    isPathways: false,
    isWarning: false,
    isHidden: false,
    isLocked: false
  }
};

export const initializeOccupationCardCategoryMap = (): Map<
  OccupationCardCategoryType,
  OccupationCategory
> => {
  const map = new Map<OccupationCardCategoryType, OccupationCategory>();

  Object.entries(UtilityService.cloneObject(categoryConfig)).forEach(
    ([key, value]) => {
      map.set(key as OccupationCardCategoryType, value);
    }
  );

  return map;
};

export const addOccupationToMap = (
  map: Map<OccupationCardCategoryType, OccupationCategory>,
  occupation: IOccupationCard
): void => {
  const category: OccupationCategory = map.get(
    occupation.occupationCardCategoryType
  );

  if (category) {
    if (!category.occupations) {
      category.occupations = [];
    }

    if (!category.occupations.some((o) => o.onetCode === occupation.onetCode)) {
      category.occupations.push(occupation);
    }
  }
};
